module.exports = __webpack_public_path__ + "img/collaborate_54.0ea59f5b.jpg";